import { render, staticRenderFns } from "./ExtLink.vue?vue&type=template&id=b3808dba&scoped=true&"
import script from "./ExtLink.vue?vue&type=script&lang=js&"
export * from "./ExtLink.vue?vue&type=script&lang=js&"
import style0 from "./ExtLink.vue?vue&type=style&index=0&id=b3808dba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3808dba",
  null
  
)

export default component.exports